/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSetQuestionReactionWebRequest,
  TSetQuestionReactionWebModel,
  IMappers,
  TSetQuestionReactionWebResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISetQuestionReactionWebResponse } from '../../entities/set_question_reaction/SetQuestionReactionWebResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSetQuestionReactionWebModel(
  parameters: TSetQuestionReactionWebRequest,
): TSetQuestionReactionWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-reviews',
    pathApi: '/v1/set-question-reaction-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISetQuestionReactionWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSetQuestionReactionWebRequest;
}

export async function fetchSetQuestionReactionWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISetQuestionReactionWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSetQuestionReactionWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSetQuestionReactionWebModel(parameters),
    config,
  )) as FetchResponse<TSetQuestionReactionWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetQuestionReactionWebResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSetQuestionReactionWebResponse>;
}
